import React from 'react';
import xLogo from '../../../assets/branding/x-logo-black.png';
import '../../../css/common/artists/ArtistSocialLinks.css';

export const ARTIST_SOCIAL_LINK_ITEMS = [
  { key: 'twitter_url', slug: 'twitter', icon: 'fa-brands fa-x-twitter', label: 'X' },
  { key: 'instagram_url', slug: 'instagram', icon: 'fa-brands fa-instagram', label: 'Instagram' },
  { key: 'facebook_url', slug: 'facebook', icon: 'fa-brands fa-facebook-f', label: 'Facebook' },
  { key: 'youtube_url', slug: 'youtube', icon: 'fa-brands fa-youtube', label: 'YouTube' },
  { key: 'hp_url', slug: 'website', icon: 'fa-solid fa-globe', label: 'HP' },
];
type SocialLinkItem = { key: string; slug: string; icon: string; label: string };
type ArtistSocialLinksProps = {
  artist: Record<string, any>;
  items?: SocialLinkItem[];
  size?: string;
  className?: string;
  ariaName?: string;
  stopPropagation?: boolean;
};

export default function ArtistSocialLinks({
  artist,
  items = ARTIST_SOCIAL_LINK_ITEMS,
  size = 'md',
  className = '',
  ariaName = '',
  stopPropagation = true,
}: ArtistSocialLinksProps) {
  const links = items.filter((item) => String(artist?.[item.key] || '').trim());
  if (!links.length) return null;

  const namePrefix = String(ariaName || artist?.name || '').trim();

  return (
    <div className={`artist-social-links artist-social-links--${size} at-sns-icons ${className}`.trim()}>
      {links.map((item) => (
        <a
          key={item.key}
          className={`artist-social-link artist-social-link--${item.slug} at-sns-link at-sns-link--${item.slug}`}
          href={artist[item.key]}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${namePrefix ? `${namePrefix}の` : ''}${item.label}`}
          title={item.label}
          onClick={stopPropagation ? (event) => event.stopPropagation() : undefined}
        >
          {item.slug === 'twitter' ? (
            <img className="sns-x-icon" src={xLogo} alt="" aria-hidden="true" />
          ) : (
            <i className={item.icon} aria-hidden="true" />
          )}
        </a>
      ))}
    </div>
  );
}
